<template>
    <div class="container" :style="!ifShowViolationList ? 'background: #fff' : 'background: #F3F6FA'">
        <div class="content">
            <login v-model="loginModel" @callback="loginCallback"></login>
            <div class="violist">
                <el-dialog :visible.sync="vindailog" width="500px" :show-close="false">
                    <img style="width:100%;cursor:pointer;" @click="vindailog= false" src="https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/img/classNo.png">
                </el-dialog>
                <el-dialog :visible.sync="enginedailog" width="500px" :show-close="false">
                    <img style="width:100%;cursor:pointer;" @click="enginedailog = false"  src="https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/img/engine.png">
                </el-dialog>
            </div>
            <el-dialog :visible.sync="showCaptcha" width="400px" title="验证码">
                <img :src="captchUrl" style="width:80%;margin-left:10%;" @click="getCaptcha"/>
                <p style="text-align:center" @click="getCaptcha">看不清？换一张</p>
                <div>
                <div style="width:80%;margin-left:10%;text-align:center;margin-top:20px">
                    <el-input
                    ref="captchValue1"
                    v-model="captchValue1"
                    :disabled="captchValue1 ? 'disabled' : false"
                    class="captch-input"
                    type="text"
                    maxlength="1"
                    @keyup.delete.native="captchDelete(1,captchValue1)" />
                    <el-input
                    ref="captchValue2"
                    v-model="captchValue2"
                    :disabled="captchValue2 ? 'disabled':false"
                    class="captch-input"
                    type="text"
                    maxlength="1"
                    @keyup.delete.native="captchDelete(2,captchValue2)" />
                    <el-input
                    ref="captchValue3"
                    v-model="captchValue3"
                    :disabled="captchValue3 ? 'disabled':false"
                    class="captch-input"
                    type="text"
                    maxlength="1"
                    @keyup.delete.native="captchDelete(3,captchValue3)" />
                    <el-input
                    ref="captchValue4"
                    v-model="captchValue4"
                    :disabled="captchValue4 ? 'disabled':false"

                    class="captch-input"
                    type="text"
                    maxlength="1"
                    @keyup.delete.native="captchDelete(4,captchValue4)" />
                </div>
                </div>
            </el-dialog>
            <div style="display: flex;">
                <el-card :class="[!ifShowViolationList ? 'nosearch' : 'search']" v-loading="loading"> 
                    <div class="vio-tabs">
                        <span style="border-right: 1px solid #EBEDF7;" :class="{vioselect: $route.path === '/'  || $route.path === '/ticketPay'}" @click="goToPage('/')">违章查询处理</span>
                        <span :class="{vioselect: $route.path === '/pay' || $route.path === '/paying'}" @click="goToPage('/pay')">罚单代缴</span>
                    </div>
                    <el-form label-width="80px" label-position='left' :class="[!ifShowViolationList ? 'nosearchForm' : 'searchForm']">
                        <el-form-item label="车辆类型">
                            <el-select v-model="car_type" placeholder="请选择车辆类型" style="width:100%">
                                <el-option
                                v-for="(item,index) in carTypeList"
                                :key="index"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="车牌号码">
                            <sprovice :allcarno="carno" v-on:changeProvice="changeProvice"/>
                        </el-form-item>
                        <el-form-item label="车架号码" v-if="vinLength !== 0">
                            <el-input v-model="vin" :placeholder='vPlaceholder'>
                                <i slot="suffix" style="cursor:pointer;color:#3A82FF" class="el-input__icon el-icon-question" @click="vindailog = true"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="发动机号" v-if="engineNoLength !== 0">
                            <el-input v-model="engine" :placeholder="ePlaceholder">
                                <i slot="suffix" style="cursor:pointer;color:#3A82FF" class="el-input__icon el-icon-question" @click="enginedailog = true"></i>
                            </el-input>
                        </el-form-item>
                        
                    <el-form-item label="最近查询" v-if="historyVioList && historyVioList.length > 0">
                            <span style="margin-right:10px;cursor:pointer;" v-for="(item,index) in historyVioList" :key="index" @click="searchHistoty(item)">
                                <el-tag type="warning"  size="small" >{{item.carno}}</el-tag>
                            </span>
                        </el-form-item>
                        <el-form-item label-width="0" style="text-align:center;" v-show="ifShowViolationList">
                            <el-button type="primary" style="margin:0 atuo;width:200px;" @click="getIllegal">查&nbsp;&nbsp;&nbsp;&nbsp;询</el-button>
                        </el-form-item>
                        <div style="text-align:center;margin-bottom:30px" v-show="!ifShowViolationList">
                            <el-button type="primary" style="margin:0 atuo;width:200px" @click="getIllegal">查&nbsp;&nbsp;&nbsp;&nbsp;询</el-button>
                        </div>
                    </el-form>
                </el-card>
                <div v-if="!ifShowViolationList" style="display: flex;display: flex;align-items: center;">
                    <div style="margin-left: 100px;width:472px;">
                        <img src="../assets/default.png" alt="" style="width:402px;height: 244px;">
                    </div>
                    <div style="font-size: 20px;color: #002257;text-align: center;margin-right:20px">
                        <qrcode-vue :value="downloadSrc_ios"></qrcode-vue>
                        <!-- <img src="https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/officeweb/code-vio.png" alt="" style="width:141px;height: 141px;"> -->
                        <p>扫码下载APP</p>
                        <p>(ios版)</p>
                    </div>
                    <div style="font-size: 20px;color: #002257;text-align: center;">
                        <qrcode-vue :value="downloadSrc_and"></qrcode-vue>
                        <!-- <img src="https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/officeweb/code-vio.png" alt="" style="width:141px;height: 141px;"> -->
                        <p>扫码下载APP</p>
                        <p>(Andriod版)</p>
                    </div>
                </div>
                
                <div v-if="ifShowViolationList && searchSuccess" style="flex:1;margin-left: 10px;">
                    <el-card>
                        <div slot="header" class="clearfix vio-header">
                            <span style="color: #002257;font-size: 20px;">{{carno}}</span>
                            <span class="blueFont">{{violationList.length}}条违章</span>
                            <span class="blueFont orFont">扣{{total.point}}分</span> 
                            <span class="blueFont redFont">罚{{total.price}}元</span>
                            <!-- <img src="../assets/app.png" alt="" class="imgfont" @mouseover='app(true)' @mouseout="app(false)"> -->
                            <div class="app-download" v-if="showapp">
                                <img src="https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/officeweb/code-vio.png" alt="" style="width:175px;height: 175px;">
                                <img src="../assets/app_sale.png" alt="" style="width:223px;height: 68px;">
                            </div>
                        </div>
                        <div v-if="violationList.length > 0">
                            <div class="vio-card" v-for="(item,index) in violationList" :key="index">
                                <div class="vio-card-left">
                                    <div style="display: flex;align-items: center;margin-bottom: 20px;">
                                        <img src="../assets/local.png" alt="local" style="width: 24px;height: 24px;margin-right: 5px;">
                                        <span style="font-size: 15px;">{{item.Address}}</span>
                                    </div>
                                    <div>
                                        <el-tag style="margin-right: 10px;font-size: 12px;" type="warning">扣{{item.ExecutePoint}}分</el-tag>
                                        <el-tag type="danger" style="font-size: 12px;">罚{{item.Fine}}元</el-tag>
                                    </div>
                                </div>
                                <div class="vio-card-right">
                                    <div style="font-size: 13px;margin-bottom: 20px;">{{item.Reason}}</div>
                                    <div style="font-size: 13px;">{{item.OccTime}}</div>
                                </div>
                                <div style="margin-left: 30px;">
                                    <el-button style="width:158px;height:40px;" type="primary" v-if="item.ProcessStatus == 1" @click="gotoTicketPay(item)">立即办理</el-button>
                                    <el-button v-else style="width:158px;height:40px;" type="info" plain>暂不可办理</el-button>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div style="text-align:center;margin:20px">
                                <img src="../assets/ill.png" style="width:317px"/>
                                <p style="color:#333;font-size:24px;font-weight:bold;margin-top:20px;margin-bottom:15px">
                                    查询成功
                                </p>
                                <p>暂无未完成交通违法</p>
                            </div>
                        </div>     
                    </el-card>
                </div>
                <div v-if="ifShowViolationList && !searchSuccess" style="flex:1;margin-left: 10px;">
                    <el-card >
                        <div slot="header" class="clearfix">
                            
                            共计: 违章 <span class="redFont">{{violationList.length}}</span> 次, 扣 <span class="redFont">{{total.point}}</span> 分, 罚款 <span class="redFont">{{total.price}}</span> 元
                        </div>
                        <div style="text-align:center;margin:20px">
                            <img src="../assets/ill.png" style="width:317px"/>
                            <p style="color:#333;font-size:24px;font-weight:bold;margin-top:20px;margin-bottom:15px">
                                查询失败
                            </p>
                            <p>{{msg}}</p>
                        </div>
                    </el-card>
                </div>
            </div>
        </div>  
    </div>
</template>
<script>
// 313注释解开
    import login from './component/Login.vue'
    import sprovice from './component/Provice.vue'
    import QrcodeVue from 'qrcode.vue';
    export default {
        components: {
            'sprovice': sprovice,
            'login':login,
            QrcodeVue,
        },
        data (){
            return {
                carno: this.$route.query.carno || '',
                vin: this.$route.query.vin || '',
                engine: this.$route.query.engine || '',
                loading:false,
                car_type: this.$route.query.car_type || '02',
                violationList: this.$store.state.violationList || [],
                ifShowViolationList: this.$store.state.ifShowViolationList || false,
                carTypeList:[{
                        value: '02',
                        label: '小型汽车'
                    },{
                        value: '01',
                        label: '大型汽车'
                    },{
                        value: '52',
                        label: '新能源小车'
                    },{
                        value: '51',
                        label: '新能源大车'
                    },{
                        value: '26',
                        label: '香港入境车'
                    },{
                        value: '27',
                        label: '澳门入境车'
                    },{
                        value: '03',
                        label: '使馆汽车'
                    },{
                        value: '04',
                        label: '领馆汽车'
                    },{
                        value: '05',
                        label: '境外汽车'
                    },{
                        value: '06',
                        label: '外籍汽车'
                    },{
                        value: '07',
                        label: '两三轮摩托车'
                    },{
                        value: '08',
                        label: '轻便摩托车'
                    },{
                        value: '09',
                        label: '使馆摩托车'
                    },{
                        value: '10',
                        label: '领馆摩托车'
                    },{
                        value: '11',
                        label: '境外摩托车'
                    },{
                        value: '12',
                        label: '外籍摩托车'
                    },{
                        value: '13',
                        label: '农用运输车'
                    },{
                        value: '14',
                        label: '拖拉机'
                    },{
                        value: '15',
                        label: '挂车'
                    },{
                        value: '16',
                        label: '教练汽车'
                    },{
                        value: '17',
                        label: '教练摩托车'
                }],
                searchSuccess: this.$store.state.ifShowViolationList || false,
                msg: '查询失败,请稍后再试',
                historyVioList:[],
                vinLength: 6,
                engineNoLength: 6,
                vindailog:false,
                enginedailog:false,
                loginModel:false,
                channel: this.$route.query.channel || '',
                codedailog: false,
                needCaptcha: false,
                captchValue1: '',
                captchValue2: '',
                captchValue3: '',
                captchValue4: '',
                captchKey: '',
                showCaptcha: false,
                captchUrl: '',
                radio: '违章查询处理',
                XcdNotice: '',
                showapp: false,
                downloadSrc_ios: "https://itunes.apple.com/cn/app/%E9%BD%90%E8%BD%A6%E5%A4%A7%E5%9C%A3/id1097885036?mt=8",
                downloadSrc_and: "https://a.app.qq.com/o/simple.jsp?pkgname=com.qichedasheng.s4s",
                vPlaceholder: `请输入车架号`,
                ePlaceholder: `请输入发动机号`,
            }
        },
        mounted(){
             if(this.$route.query.channel) {
                this.channel = this.$route.query.channel || ''
                window.localStorage.channel = this.$route.query.channel || ''
            }
            if(this.$store.state.selectVioSearch && this.$store.state.selectVioSearch.carno) {
                this.carno = this.$store.state.selectVioSearch.carno || '',
                this.vin = this.$store.state.selectVioSearch.vin || '',
                this.engine = this.$store.state.selectVioSearch.engine || '',
                this.car_type = this.$store.state.selectVioSearch.car_type || '',
                this.$request('v3/violation/rule', {
                    prefix: this.carno.substring(0,1)
                }).then((xhr, res) => {
                    if(res.code == 20022) {
                        return;
                    }
                    if (res.code > 40000 && res.code < 50000) {
                        return;
                    }
                    if (res.code == 0) {
                        this.vinLength = res.data.vinLength
                        this.engineNoLength = res.data.engineNoLength
                        this.vPlaceholder = `请输入${res.data.vinLength == 99 ? '完整数' : res.data.vinLength}位车架号`
                        this.ePlaceholder = `请输入${res.data.engineNoLength == 99 ? '完整数' : res.data.engineNoLength}位发动机号`
                        this.getIllegal()
                    } else {
                        this.$message.error(res.msg)
                    }
                });
            }
            if(this.$route.query.carno) {
                this.$request('v3/violation/rule', {
                    prefix: this.carno.substring(0,1)
                }).then((xhr, res) => {
                    if(res.code == 20022) {
                        return;
                    }
                    if (res.code > 40000 && res.code < 50000) {
                        return;
                    }
                    if (res.code == 0) {
                        this.vinLength = res.data.vinLength
                        this.engineNoLength = res.data.engineNoLength
                        this.vPlaceholder = `请输入${res.data.vinLength == 99 ? '完整数' : res.data.vinLength}位车架号`
                        this.ePlaceholder = `请输入${res.data.engineNoLength == 99 ? '完整数' : res.data.engineNoLength}位发动机号`
                        this.getIllegal()
                    } else {
                        this.$message.error(res.msg)
                    }
                });
            }
            try{
                this.historyVioList = JSON.parse(window.localStorage.historyVioList)
            }
            catch{
                return []
            }
            this.getNotice();
            
        },
        computed:{
            total(){
                let point = 0;
                let price = 0;
                if(this.violationList && this.violationList.length > 0){
                    this.violationList.forEach(val => {
                        point += Number(val.ExecutePoint)
                        price += Number(val.Fine)
                    });
                }
                return {
                    point,
                    price
                }
            },
        },
        watch:{
            carno(val){
                this.$request('v3/violation/rule', {
                    prefix: val.substring(0,1)
                }).then((xhr, res) => {
                    if(res.code == 20022) {
                        return;
                    }
                    if (res.code > 40000 && res.code < 50000) {
                        return;
                    }
                    if (res.code == 0) {
                        this.vinLength = res.data.vinLength
                        this.engineNoLength = res.data.engineNoLength
                        this.vPlaceholder = `请输入${res.data.vinLength == 99 ? '完整数' : res.data.vinLength}位车架号`
                        this.ePlaceholder = `请输入${res.data.engineNoLength == 99 ? '完整数' : res.data.engineNoLength}位发动机号`
                    } else {
                        this.$message.error(res.msg)
                    }
                });
            },
            captchValue1 (val) {
                if (val.length === 1) {
                    this.$refs['captchValue2'].focus()
                }
                // 备用逻辑  如果本格内容为两位以上，可以传递给下一格
                // else if (val.length === 2) {
                //   this.captchValue1 = val.substring(0, 1)
                //   this.captchValue2 = ''
                //   this.captchValue2 = val.substring(1, 2)
                // }
                if (this.captchValue4 && this.captchValue2 && this.captchValue3) {
                    this.captchReady()
                }
                // 当前逻辑 输入后不可修改，只能从最后一位进行删除，满足四位进行查询
            },
            captchValue2 (val) {
                if (val.length === 1) {
                    this.$refs['captchValue3'].focus()
                }
                if (this.captchValue1 && this.captchValue4 && this.captchValue3) {
                    this.captchReady()
                }
            },
            captchValue3 (val) {
                if (val.length === 1) {
                    this.$refs['captchValue4'].focus()
                }
                if (this.captchValue1 && this.captchValue2 && this.captchValue4) {
                    this.captchReady()
                }
            },
            captchValue4 (val) {
                if (val.length === 1) {
                    if (this.captchValue1 && this.captchValue2 && this.captchValue3) {
                    this.captchReady()
                    } else {
                    this.$refs['captchValue4'].blur()
                    }
                }
            }
        },
        methods:{
            captchDelete (index) {
                switch (index) {
                    case 1:
                    break
                    case 2:
                    if (this.captchValue2 === '') {
                        this.captchValue1 = ''
                        setTimeout(() => { this.$refs.captchValue1.focus() }, 0)
                    }
                    break
                    case 3:
                    if (this.captchValue3 === '') {
                        this.captchValue2 = ''
                        setTimeout(() => { this.$refs.captchValue2.focus() }, 0)
                    }
                    break
                    case 4:
                    if (this.captchValue4 === '') {
                        this.captchValue3 = ''
                        setTimeout(() => { this.$refs.captchValue3.focus() }, 0)
                    }
                    break
                    default:
                    break
                }
            },
            captchReady () {
                this.getIllegal()
            },
            getCaptcha () {
                const that = this
                this.$request('v3/captcha', {
                    width: 180,
                    height: 80,
                    cap_len: 4,
                    dot_count: 80,
                    skew: 1
                }).then((xhr, res)=> {
                    if (res.code === 0) {
                    that.captchKey = res.data.key
                    that.captchUrl = res.data.image
                    that.captchValue1 = ''
                    that.captchValue2 = ''
                    that.captchValue3 = ''
                    that.captchValue4 = ''
                    setTimeout(() => { that.$refs.captchValue1.focus() }, 0)
                    }
                })
            },
            changeProvice(carno){
                this.carno = carno
            },
            searchHistoty(item){
                this.carno = item.carno
                this.vin = item.vin
                this.engine = item.engine
                this.car_type = item.car_type
                this.$request('v3/violation/rule', {
                    prefix: this.carno.substring(0,1)
                }).then((xhr, res) => {
                    if(res.code == 20022) {
                        return;
                    }
                    if (res.code > 40000 && res.code < 50000) {
                        return;
                    }
                    if (res.code == 0) {
                        this.vinLength = res.data.vinLength
                        this.engineNoLength = res.data.engineNoLength
                        this.vPlaceholder = `请输入${res.data.vinLength == 99 ? '完整数' : res.data.vinLength}位车架号`
                        this.ePlaceholder = `请输入${res.data.engineNoLength == 99 ? '完整数' : res.data.engineNoLength}位发动机号`
                        this.getIllegal()
                    } else {
                        this.$message.error(res.msg)
                    }
                });
            },
            getIllegal() {
                // if(!window.localStorage.UserTel) {
                //     this.loginModel = true
                //     return
                // }
                let car = /(^[\u4E00-\u9FA5]{1}[A-Z0-9]{6}$)|(^[\u4E00-\u9FA5]{1}[A-Z0-9]{7}$)|(^[A-Z]{2}[A-Z0-9]{2}[A-Z0-9\u4E00-\u9FA5]{1}[A-Z0-9]{4}$)|(^[\u4E00-\u9FA5]{1}[A-Z0-9]{5}[挂学警军港澳]{1}$)|(^[A-Z]{2}[0-9]{5}$)|(^(08|38){1}[A-Z0-9]{4}[A-Z0-9挂学警军港澳]{1}$)/
                if(this.carno) {
                    this.carno = this.carno.replace(/\s+/g, "")
                    this.carno = this.carno.toUpperCase()
                }
                if (!this.carno) {
                    this.$message.error('请您输入车牌号');
                    return;
                } else if(!car.test(this.carno)){
                    this.$message.error("您输入车牌号码的有误");
                    return
                }
                if(!this.car_type) {
                    this.$message.error("请您选择车辆类型");
                    return
                }
                if(this.vinLength !== 0) {
                    if(!this.vin ) {
                        this.$message.error('请您输入车架号');
                        return
                    }else if (this.vin.length < 6){
                        this.$message.error('请您输入正确的车架号');
                        return
                    }
                }
                if(this.engineNoLength !== 0) {
                    if(!this.engine) {
                        this.$message.error('请您输入发动机号');
                        return
                    }else if(this.engine.length < 6){
                        this.$message.error('请您输入正确的发动机号');
                        return
                    }
                }
                
                let self = this;
                let param = {
                    car_no: this.carno ? this.carno.toUpperCase() : "",
                    vin: this.vin ? this.vin.toUpperCase() : "",
                    engine: this.engine ? this.engine.toUpperCase() : "",
                    car_type: this.car_type || '',
                };
                if (this.needCaptcha) {
                    param.key = this.captchKey
                    param.value = [this.captchValue1, this.captchValue2, this.captchValue3, this.captchValue4].join('')
                }
                this.loading = true
                // carno车牌号，vin车架号，engine发动机，{carno: 陕KC1166 vin: LSVNJ49J472028756 engine: 020297
                this.$request("v3/violation/web/query", param).then((xhr, res) => {
                    self.loading = false
                    if (res.code === 90027) {
                        self.getCaptcha()
                        this.$message.error(res.msg ||"需要填写验证码");
                        self.needCaptcha = true
                        self.showCaptcha = true
                        self.msg = res.msg ? res.msg : '查询失败,请稍后再试'
                        self.searchSuccess = false
                        self.$store.state.searchSuccess = false
                        return
                    }else {
                        self.needCaptcha = false
                        self.showCaptcha = false
                    }
                    if(res.code == 20022) {
                        self.loginModel = true
                        return;
                    }
                    if (res.code >= 40000 && res.code < 50000) {
                        self.loginModel = true
                        return;
                    }
                    self.ifShowViolationList = true
                    self.$store.state.ifShowViolationList = true
                    self.violationList = []
                    self.$store.state.violationList = []
                    if (res.code == 0 && res.data) {
                        let newVio = {
                            carno: self.carno || '',
                            vin:self.vin || '',
                            engine: self.engine || '',
                            car_type: self.car_type || ''
                        }
                        let historyVioList = this.historyVioList
                        let newhistoryVioList = historyVioList
                        newhistoryVioList.forEach((val,index) =>{
                            if (val.carno == newVio.carno){
                                historyVioList.splice(index,1)
                            }
                        })
                        historyVioList.unshift(newVio)
                        this.$store.state.selectVioSearch = newVio
                        this.historyVioList = historyVioList.slice(0,3)
                        window.localStorage.historyVioList = JSON.stringify(historyVioList.slice(0,3))
                        
                        if (res.data.Records && res.data.Records.length > 0) {
                            let newList = []
                            res.data.Records.forEach(function(item) {
                                newList.push({
                                    OccTime: item.OccTime,
                                    Address: item.Address,
                                    Reason: item.Reason,
                                    Fine: item.Fine,
                                    Status: item.Status,
                                    Point: item.Point,
                                    ViolationCode: item.ViolationCode,
                                    ViolationWritNo: item.ViolationWritNo,
                                    Category: item.Category,
                                    Locationid: item.Locationid,
                                    LocationName: item.LocationName,
                                    Free: item.Free,
                                    CooperFree: item.CooperFree,
                                    ProcessStatus: item.ProcessStatus,
                                    ProcessMsg: item.ProcessMsg,
                                    ExecutePoint: item.ExecutePoint,
                                    FreeCode: item.FreeCode,
                                    FreeRule: item.FreeRule,
                                    FreeRuleObject: item.FreeRuleObject || {},
                                    ViolationId: item.ViolationId,
                                    CarNo: self.carno ? self.carno.toUpperCase() : "",
                                    vin: self.vin ? self.vin.toUpperCase() : "",
                                    engine: self.engine ? self.engine.toUpperCase() : ""
                                });
                            });
                            self.violationList = newList
                            self.$store.state.violationList = newList
                        }
                        self.searchSuccess = true
                        self.$store.state.searchSuccess = true
                    } else {
                        this.msg = res.msg ? res.msg : '查询失败,请稍后再试'
                        self.searchSuccess = false
                        self.$store.state.searchSuccess = false
                    }
                }).catch(function() {
                    self.loading = false
                    self.ifShowViolationList = true
                    self.$store.state.ifShowViolationList = true
                    self.searchSuccess = false
                    self.$store.state.searchSuccess = false
                    self.violationList = []
                    self.$store.state.violationList = []
                });
            },
            goToPage(path) {
                this.$store.state.orderNumber = ''
                this.$store.state.handFill = {
                    nick: '',
                    nickCarNo:'',
                    date:'',
                    ticketUrl: '',
                    price: '',
                    ownFree: 0,
                    lateFree:  0,
                    showForm1: false,
                    showForm2: false,
                    showNotice: true,
                    drive_no: false,
                }
                this.$router.push({
                    path: path,
                })
            },
            gotoTicketPay(item, pass) {
                if (this.XcdNotice && !pass) {
                    this.$alert(this.XcdNotice.Content, this.XcdNotice.Title, {
                        confirmButtonText: '我知道了',
                        callback: () => {
                            let pass = true
                            this.gotoTicketPay(item, pass);
                        }
                    });
                    // this.$alert('我知道了','我知道了',{
                    //     confirmButtonText: '我知道了',
                    //     callback: action => {
                    //         let pass = true
                    //         this.gotoTicketPay(item, pass);
                    //     }
                    // });
                    return;
                }
                this.$store.commit('SET_ILLEGAL', item);
                this.$router.push({
                    path: '/ticketPay',
                    query: {
                        id: item.ViolationId
                    }
                });
                this.$store.state.ticketPay = {
                    driveUrl: '',
                    travelUrl: '',
                    JSZTravelUrl: '',
                    JSZDriveUrl: '',
                }
            },
            getNotice() {
                this.$request('v3/violation/view/notice').then((xhr, res) => {
                    if (res.code === 0 && res.data) {
                        if (res.data.XcdHave) {
                            this.XcdNotice = res.data.XcdNotice;
                        }
                    } else {
                        this.XcdNotice = null;
                    }
                }).catch(() => {
                    this.XcdNotice = null;
                });
            },
            loginCallback(){
                this.getIllegal()
                this.$emit('getLogin')
            },
            // app(show){
            //     this.showapp = show
            // }
        }
    }
</script>
<style scoped>
#canvas{width:175px!important;height:175px!important;}
.container{
    flex: 1;
}
.vio-header{
    line-height: 60px;
    /* border-bottom: 1px solid #EBEDF7;
    background: #fff; */
    display: flex;
    align-items: center;
    position: relative;
}
.vio-card{
    background: #FAFDFF;
    padding: 15px;
    margin: 15px 0;
    border: 1px solid #EBEDF7;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.vio-card-left{
    flex: 1;
    display: flex;
    flex-direction: column;
}
.vio-card-right{
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 10px;
}

.blueFont{
    color:#0064FF;
    font-size:14px;
    font-weight:bold;
    margin-left: 30px;
}
.orFont{
    color: #DE8700;
}
.redFont{
    color: #FF0000;
}
.nosearch {
    width:440px;
    box-sizing:border-box;
    height: 100%;
}
.search {
    width:440px;
    box-sizing:border-box;
    height: 100%;
}
.nosearchForm{
    width:100%;
}
.vio-tabs{
    width: 100%;
    height: 50px;
    margin: 5px 0 25px;
    border: 1px solid #EBEDF7;
    display: flex;
}
.vio-tabs span{
    flex: 1;
    text-align: center;
    line-height: 50px;
    color: #002257;
    font-size: 16px;
}
.vio-tabs .vioselect{
    color: #3A82FF;
    border-bottom: 2px solid #3A82FF;
}
.searchForm{
    width:100%;
}
/* .searchForm .el-form-item{
    float:left !important;
    width:50%;
} */
.captch-input {
    width:40px;
    height:40px;
    margin-left:20px;
    text-align: center
}
.captch-input:first-child{
    margin:0;
}
</style>
<style>
.searchForm .el-form-item .el-form-item__content{
    line-height: 42px;
}
.violist .el-dialog__header{
    padding:0;
}
.violist .el-dialog__body{
    padding:0;
}
</style>
